import React from "react";

export default function ButtonComponent({IsLoading,hasStopped, disabled,icon, text, badge, arrow, children, handleClick,...rest}) {
    return (
        <button onClick={handleClick} disabled={disabled} style={{cursor:disabled?"no-drop":"pointer",backgroundColor:disabled?"gray":"#f0ba18",color: "black"}} className="mc-btn primary">
            { icon && <i className="material-icons">{ icon }</i> }
            { text && <span>{ disabled&&!hasStopped?'Please Wait...':text }</span> }
            { badge && <sup className={ badge.variant }>{ badge.text }</sup> }
            { arrow && <small className="material-icons">{ arrow }</small>}
            { children }
        </button>
    );
}